var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.characterBlock)?_c('svg',{style:({ width: '100%', filter: _vm.filter }),attrs:{"height":"10"}},[_c('line',{attrs:{"x1":"0","y1":"5","x2":"100%","y2":"5","stroke":"rgba(0,0,0,0.54)","stroke-width":"0.1rem","stroke-dasharray":_vm.dashArray}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }